module.exports = __webpack_public_path__ + "img/888.fabb4c5c.png";